import React from 'react';
import { Modal } from 'react-bootstrap';

import MaintenanceOrderListContainer from '../containers/MaintenanceOrderListContainer.jsx';
import MaintenanceOrderFlowEditContainer from '../containers/MaintenanceOrderFlowEditContainer.jsx';
import MaintenanceOrderEditContainer from '../containers/MaintenanceOrderEditContainer.jsx';
import MaintenanceOrderDetailEditContainer from '../containers/MaintenanceOrderDetailEditContainer.jsx';
import MaintenanceOrderViewContainer from '../containers/MaintenanceOrderViewContainer.jsx';

const MaintenanceOrdersComponent = ({
  // state
  showAddOrderModal,
  showEditOrderModal,
  showEditOrderDetailModal,
  showViewOrderModal,
  // dispatch
  closeModal
}) => (

    <div>
      <h4>清洗標案管理</h4>
      <MaintenanceOrderListContainer />
      <Modal bsSize="large" show={showAddOrderModal} onHide={closeModal} backdrop="static">
        <Modal.Header closeButton ><Modal.Title>新增清洗維修訂單</Modal.Title></Modal.Header>
        <Modal.Body>
          <MaintenanceOrderFlowEditContainer />
        </Modal.Body>
      </Modal>
      <Modal bsSize="large" show={showEditOrderModal} onHide={closeModal} backdrop="static">
        <Modal.Header closeButton ><Modal.Title>修改清洗維修訂單資訊</Modal.Title></Modal.Header>
        <Modal.Body>
          <MaintenanceOrderEditContainer />
        </Modal.Body>
      </Modal>
      <Modal bsSize="large" show={showEditOrderDetailModal} onHide={closeModal} backdrop="static">
        <Modal.Header closeButton  ><Modal.Title>修改清洗維修訂單細項</Modal.Title></Modal.Header>
        <Modal.Body>
          <MaintenanceOrderDetailEditContainer />
        </Modal.Body>
      </Modal>
      <Modal bsSize="large" show={showViewOrderModal} onHide={closeModal} backdrop="static">
        <Modal.Header closeButton  ><Modal.Title>檢視清洗維修訂單內容</Modal.Title></Modal.Header>
        <Modal.Body>
          <MaintenanceOrderViewContainer />
        </Modal.Body>
      </Modal>
    </div>

  );

export default MaintenanceOrdersComponent;


// WEBPACK FOOTER //
// ./src/components/MaintenanceOrdersComponent.jsx